import {loadDetailContent} from "../../grid/detail";

export function handleWindowHistory() {
	window.onpopstate = function(event) {
		if (event.state != null) {
			if (typeof event.state.title != 'undefined') {
				document.title = event.state.title
			}

			if (typeof event.state.type != 'undefined') {
				if (event.state.type == 'detail') {
					var pk = window.location.hash.replace('#!detail-', '')

					var node = gridSettings.api.getRowNode(pk)
					node.setSelected(true, true)

					loadDetailContent(pk, false)
				} else if (event.state.type == 'task') {
					// loadTaskContent();
				}
			}
		} else if (event.state == null && window.location.hash.match(/^#\!task\-/)) {
			// loadTaskContent();
		} else {
			var $list = $('[data-role="list"]')
			var $detail = $('[data-role="detail"]')

			if ($list.length == 1 && $detail.length == 1) {
				$list.show();
				$detail.hide();
			}

			let modalWindow = $('body').closest("[data-role=window]").data("kendoWindow");
			if (typeof modalWindow !== 'undefined') {
				modalWindow.close();
			}
		}
	}
}
